// extracted by mini-css-extract-plugin
export default {"import":"Import_import__ScCba","title":"Import_title__pNL3v","btn":"Import_btn__cIoBB","icons":"Import_icons__qeSJj"};